// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3U09Q","header":"PatientQuestionnaire_header__3O-Ax","info":"PatientQuestionnaire_info__UGal6"};